import React from 'react';
import classnames from 'classnames';
import { getIn } from 'formik';

import styles from '../fieldStyles';

const InputField = ({
  id = '',
  field,
  form: { isSubmitting, errors, touched },
  label,
  overrideStyles = {},
  customStyles = {},
  disabled,
  onClick
}) => {
  const error = getIn(errors, field.name);
  const isTouched = getIn(touched, field.name);

  return (
    <div className={classnames(styles.fieldContainer, customStyles.fieldContainer)}>
      <label id={id} className={classnames(styles.checkbox, overrideStyles.checkbox)}>
        <input
          type="checkbox"
          {...field}
          onClick={onClick}
          checked={field.value}
          disabled={isSubmitting || disabled}
        />
        <span className={classnames(styles.checkboxLabel, overrideStyles.checkboxLabel)}>
          {label}
        </span>
      </label>
      {isTouched && error && (
        <div className={classnames(styles.fieldError, customStyles.fieldError)}>{error}</div>
      )}
    </div>
  );
};

export default InputField;
